import { render } from "./ManuallyBind.vue?vue&type=template&id=64a80158"
import script from "./ManuallyBind.vue?vue&type=script&lang=js"
export * from "./ManuallyBind.vue?vue&type=script&lang=js"

import "./ManuallyBind.vue?vue&type=style&index=0&id=64a80158&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__